import { createRouter, createWebHistory } from 'vue-router'
//First Root
import HomeView from '../views/Home.vue'
import ContactUs from '../views/ContactUs.vue'
import experts from '../views/experts.vue'
import waterAnalysis from '../views/waterAnalysis.vue'
import waterPump from '../views/waterPump.vue'
import services from '../views/services.vue'
import armstrong from '../views/Armstrong.vue'
import products from '../views/products.vue'
import productDetailed from '../views/productDetailed.vue'
import Policy from '../views/Policy.vue'

//Product Root
import highPressureWasher from '../views/Products/highPressureWasher.vue'
import waterFilterAndTreatment from '../views/Products/waterFilterAndTreatment.vue'
import PVC40 from '../views/PVC40.vue'
import PVC80 from '../views/PVC80.vue'

//Services Root
import reparePump from '../views/Services/reparePump.vue'
import Vaccum from '../views/Vaccum.vue' 
import Forage from '../views/Forage.vue'


const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  { path: '/:pathMatch(.*)*', redirect: '/' },
  {
    path: '/contact',
    name: 'ContactUs',
    component: ContactUs
  },
  {
    path: '/experts',
    name: 'experts',
    component: experts
  },
  {
    path: '/analyseEau',
    name: 'waterAnalysis',
    component: waterAnalysis
  },
  {
    path: '/Pompes',
    name: 'waterPump',
    component: waterPump
  },
  {
    path: '/services',
    name: 'services',
    component: services
  },
  {
    path: '/forage',
    name: 'Forage',
    component: Forage
  },
  {
    path: '/armstrong',
    name: 'armstrong',
    component: armstrong
  },
  {
    path: '/produits',
    name: 'products',
    component: products
  },
  {
    path: '/produit/:id',
    name: 'productDetailed',
    component: productDetailed
  },
  {
    path: '/PolitiqueDeConfidentialiter',
    name: 'Policy',
    component: Policy
  },
  //product route
  {
    path: '/laveuse_haute_pression',
    name: 'highPressureWasher',
    component: highPressureWasher
  },

  {
    path: '/filtre_a_eau',
    name: 'waterFilterAndTreatment',
    component: waterFilterAndTreatment
  },
  {
    path: '/RéparationPompe',
    name: 'reparePump',
    component: reparePump
  },
  {
    path: '/vaccum',
    name: 'Vaccum',
    component: Vaccum
  },
  {
    path: '/PVC40',
    name: 'PVC40',
    component: PVC40
  },
  {
    path: '/PVC80',
    name: 'PVC80',
    component: PVC80
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, SavedPosition) {
    if (to.hash) {
      const el = window.location.href.split("#")[1];
      setTimeout(() => {
        if (el.length) {
          const offset = 150; // Décalage en pixels, ajustez selon vos besoins
          const elPosition = document.getElementById(el).getBoundingClientRect().top + window.pageYOffset;
          const scrollToPosition = elPosition - offset;
          window.scrollTo({
            top: scrollToPosition,
            behavior: "smooth"
          });
        }
      }, 5);
      
    } else if (SavedPosition) {
      return SavedPosition;
    } else {
      document.getElementById("app").scrollIntoView({ behavior: "smooth" });
    }
  },
})

export default router
